import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { withScope, QueryParam } from '@bingads-webui-react/scope-service';

import { getCampaignType } from './campaign-type-map';

export function withCampaignType(Component) {
  const Wrapper = (props) => {
    const {
      scope: { values: { campaignId } },
    } = props;
    const campaignIdNumber = Number(campaignId);
    if (campaignIdNumber <= 0 || _.isNaN(campaignIdNumber)) {
      return <Component {...props} campaignType="" />;
    }
    return (
      <Component
        {...props}
        campaignType={getCampaignType(campaignIdNumber)}
      />
    );
  };

  Wrapper.propTypes = {
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return withScope(Wrapper);
}
